import { AdminProctorList, AdminProctorSearchFilterSection } from '@exam-center/admin-proctor-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Box, PaperSection, Flex, Divider } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function AdminProctorListPage() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR.VIEW]}>
      <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
        <PaperSection title='ผู้คุมสอบทั้งหมด'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(4),
              p: theme.spacing(6),
            })}
          >
            <AdminProctorSearchFilterSection />
            <Flex
              sx={(theme) => ({
                borderRadius: theme.shape.rounded(2),
                border: '1px solid',
                borderColor: theme.palette.grey[200],
                flexDirection: 'column',
                overflow: 'hidden',
                flexGrow: 1,
              })}
            >
              <Divider
                sx={{
                  mt: '-1px',
                }}
              />
              <AdminProctorList />
            </Flex>
          </Flex>
        </PaperSection>
      </Box>
    </PermissionGuard>
  );
}
